import React, { useState } from 'react';
import { Button, Col, ControlLabel, FormGroup, Grid, Modal, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { Add, Save } from '../../Icons/Icons';
import { ModalData } from '../../Modals/ModalData';
import { CustomSearchBox } from '../../CustomControls/CustomSearchBox';

const GroupPatientForm = ({ props, deleteAllPatientsButton, addPatientsButton }) => {
    const { t } = useTranslation();
    const [isShowing, setIsShowing] = useState(false);

    const {
        dataPatient,
        queryPatient,
        totalSizePatient,
        isPatientLoading,
        handleTableChangePatient,
        addPatients_Handler,
        handleFilterChange,
        selectedPatient,
        confirmPatient,
        allPatientsUserAssignments,
        groupPatientLimit,
        currentGroupPatientCount,
    } = props;

    const patientStatusOptions = [
        //{ id: 0, code: 'all', title: 'all' },
        { id: 1, code: 'asigned', title: t("protocols.groups.assigned") },
        { id: 2, code: 'unasigned', title: t("protocols.groups.unassigned") },
    ];
    
    return (
        <>
            <div className="row">
                {addPatientsButton }

                {groupPatientLimit > 0 &&
                    <div className="col-md-3" style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{t('protocols.groups.patientCount', { current: currentGroupPatientCount ?? 0, limit: groupPatientLimit })}</span>
                    </div>
                }

                <div className="col-md-3">
                    <CustomSearchBox handleSearch={(value) => handleFilterChange("FullName", value)} placeholder={t('protocols.visitTracking.searchByNumber')}></CustomSearchBox>
                </div>

                <div className="col-md-3">
                    <CustomSelect
                        name="AssignmentStatus"
                        placeholder={t("protocols.groups.all")}
                        onChange={handleFilterChange}
                        isMulti={false}
                        isClearable={true}
                        options={patientStatusOptions}
                    />
                </div>

                {deleteAllPatientsButton}

            </div>
        </>
    );
};

export default GroupPatientForm;